import { DataTableWrapper } from "@/Components/datatable/data-table"
import { getUpcomingDeliverablesColumns, UpcomingDeliverable, columnDisplayNames } from "@/Components/UpcomingDeliverables_table/columns"
import React from "react";
import { useContext, useState } from "react";
import { AppContext } from "@/App";
import { useNavigate } from "react-router-dom";

export type UpcomingDeliverableColumnVisibility = {
    id: boolean
    workstream: boolean
    workPackage: boolean
    deliverable: boolean
    actualFinish: boolean
    status: boolean
    plannedFinish: boolean
    owner: boolean
}

interface UpcomingDeliverablesProps {
  visibility?: UpcomingDeliverableColumnVisibility
}

function UpcomingDeliverablesTable({ visibility }: UpcomingDeliverablesProps) {
  const app = useContext(AppContext);
  const [upcomingDeliverablesContent, setUpcomingDeliverablesContent] = useState<UpcomingDeliverable[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const navigate = useNavigate();

  React.useEffect(() => {
    setLoading(true);
    fetch("Reports/deliverables/" + app.selectedProject?.id)
      .then(response => response.json())
      .then(data => {
        setUpcomingDeliverablesContent(data);
        setLoading(false);
      })
  }, [app.selectedProject])

  function loadColumnVisibility() : UpcomingDeliverableColumnVisibility {
    if (visibility) {
      return visibility;
    }
    const localStorageValue = localStorage.getItem(app.applicationUser?.id + "_Upcoming Deliverables_columnVisibility");
    if (localStorageValue) {
      const visibiltyValues: { columnId: string, isVisible: boolean }[] = JSON.parse(localStorageValue);
      return ({
        id: visibiltyValues.find((v) => v.columnId === "id")?.isVisible ?? false,
        workstream: visibiltyValues.find((v) => v.columnId === "workstream")?.isVisible ?? false,
        workPackage: visibiltyValues.find((v) => v.columnId === "workPackage")?.isVisible ?? true,
        deliverable: visibiltyValues.find((v) => v.columnId === "deliverable")?.isVisible ?? true,
        actualFinish: visibiltyValues.find((v) => v.columnId === "actualFinish")?.isVisible ?? true,
        status: visibiltyValues.find((v) => v.columnId === "status")?.isVisible ?? true,
        plannedFinish: visibiltyValues.find((v) => v.columnId === "plannedFinish")?.isVisible ?? true,
        owner: visibiltyValues.find((v) => v.columnId === "owner")?.isVisible ?? true,
    })
  }
    return {
      id: false,
      workstream: false,
      workPackage: true,
      deliverable: true,
      actualFinish: true,
      status: true,
      plannedFinish: true,
      owner: true,
    }
  }

  return (
          <DataTableWrapper
              columns={getUpcomingDeliverablesColumns(app)}
              data={upcomingDeliverablesContent}
              setData={setUpcomingDeliverablesContent}
              loading={loading}
              viewOnly={true}
              table_title="Upcoming Deliverables"
              columnDisplayNames={columnDisplayNames}
              columnVisibility={loadColumnVisibility()}
              onRowClick={(row) => navigate('/Plan', { state: { passedTaskId: row.original.id } })}
          />
  )
}

export default UpcomingDeliverablesTable